import script from "./UploadNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadNew.vue?vue&type=script&lang=ts&setup=true"

import "./UploadNew.vue?vue&type=style&index=0&id=20041c86&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20041c86"]])

export default __exports__